import * as THREE from 'three'
import GUI from 'lil-gui'
import gsap from 'gsap'
import './darkmode.js';
import './navBehaviour.js';
import './textObserver.js';
import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'



import { showTime, showTemp } from './navBehaviour.js';
// import { create } from 'node:domain'
gsap.registerPlugin(ScrollTrigger)
/**
 * Debug
 */
const gui = new GUI()
//delete this to see gui
gui.hide()

const parameters = {
    materialColor: '#ffeded',
    bgColor: '#ECEBE8',
    textColor: '#0B0A0F',
    yellowColor: '#DCA33B',
    blueColor: '#1694BC',
    redColor: '#9D1D25'
}

// Portfolio colours for resume as an update.
// blue 1694BC
// Yellow DCA33B
// red 9D1D25
// Black 0B0A0F
// BG ECEBE8
gui
    .addColor(parameters, 'materialColor')
    .onChange(() => {
        material.color.set(parameters.materialColor)
        particlesMaterial.color.set(parameters.materialColor)
    }
    )



/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

const lenis = new Lenis({
    // Increase this slightly if you want the scroll momentum to last longer
    duration: 1.5, 
    
    // A much softer, floatier easing curve for standard scrolling
    easing: (t) => 1 - Math.pow(1 - t, 4), 
    
    smooth: true,
})
window.lenis = lenis;

lenis.on('scroll', ScrollTrigger.update)
// 1. Grab the HTML elements
const snapElements = gsap.utils.toArray(".snap-target");

ScrollTrigger.create({
    trigger: document.body,
    start: "top top",
    end: "max",
    snap: {
    snapTo: (progress, self) => {
        const snapPoints = snapElements.map(el => {
            const sectionY = el.getBoundingClientRect().top + window.scrollY;
            return sectionY / self.end; 
        });
        return gsap.utils.snap(snapPoints, progress);
    },
    // 1. THE BREATHE ROOM: Increase the time it takes to settle so it floats instead of yanking
    duration: { min: 0.4, max: 1.0 }, 
    
    // 2. KILL THE PAUSE: Tell GSAP to take over the exact millisecond Lenis finishes
    delay: 0, 
    
    // 3. THE GENTLE CURVE: Swap 'power3' (heavy magnet) for 'sine' (soft drifting)
    ease: "sine.inOut" 
}
});
// THE KEYBOARD INTERCEPTOR
window.addEventListener('keydown', (e) => {
    // Only hijack the Up and Down arrow keys
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); // Stop Lenis from doing its default continuous scroll
        
        const currentScroll = window.scrollY;
        let targetSection = null;

        if (e.key === 'ArrowDown') {
            // Find the FIRST section whose top is physically below our current scroll position
            targetSection = snapElements.find(sec => {
                const sectionTop = sec.getBoundingClientRect().top + window.scrollY;
                // We add a 10px buffer so it doesn't accidentally detect the section we are currently sitting on
                return sectionTop > currentScroll + 10; 
            });
        } 
        else if (e.key === 'ArrowUp') {
            // Reverse the array to search from the bottom-up, finding the FIRST section above us
            targetSection = [...snapElements].reverse().find(sec => {
                const sectionTop = sec.getBoundingClientRect().top + window.scrollY;
                return sectionTop < currentScroll - 10;
            });
        }

        // If a next/previous section exists, tell Lenis to glide exactly to it
        if (targetSection) {
            lenis.scrollTo(targetSection, { 
                // You can change duration to 0 if you want an instant teleport, 
                // but 0.8 keeps that floaty, premium glide!
                duration: 0.8, 
                easing: (t) => 1 - Math.pow(1 - t, 4) 
            });
        }
    }
});

// Scene
const scene = new THREE.Scene()


/**
 * Objects
 */

//Texture
//const textureLoader = new THREE.TextureLoader()
const loadingManager = new THREE.LoadingManager()
loadingManager.onStart = () => {
    console.log('loading started')
}
loadingManager.onLoad = () => {
    console.log('loading finished')
    //renders all Items before getting into the scene.
    renderer.compile(scene, camera);
    // THE FIX: Wait 100 milliseconds for the DOM to settle, then force GSAP to recalculate all snap targets
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 100);
    //could add a loading menu here
}
loadingManager.onProgress = () => {
    console.log('loading progressing')
}
loadingManager.onError = () => {
    console.log('loading error')
}

const textureLoader = new THREE.TextureLoader(loadingManager)

const loadOptimizedTexture = (path) => {
    const texture = textureLoader.load(path);
    
    // Apply our performance armor to every image that passes through here
    texture.generateMipmaps = false;
    texture.minFilter = THREE.LinearFilter;
    
    return texture;
}

//young me texture
const croppedLittleMeTexture = loadOptimizedTexture('textures/littleMeTexture.jpg')
const croppedLittleMeAlpha = loadOptimizedTexture('textures/littleMeAlpha.jpg')
const LittleMeInnerAlpha = loadOptimizedTexture('textures/littleMeInnerAlpha.jpg')
const LittleMeInner2Alpha = loadOptimizedTexture('textures/littleMeInner2Alpha.jpg')
const LittleMeMidAlpha = loadOptimizedTexture('textures/littleMeMidAlpha.jpg')
const LittleMeMiddleAlpha = loadOptimizedTexture('textures/littleMeMiddleAlpha.jpg')
const LittleMeMid2Alpha = loadOptimizedTexture('textures/littleMeMid2Alpha.jpg')

//Uni section
const teamBackAlpha = loadOptimizedTexture('textures/teamworkBackAlpha.jpg')
const teamHandAlpha = loadOptimizedTexture('textures/teamworkHandsAlpha.jpg')
const teamHandTexture = loadOptimizedTexture('textures/teamworkHandsTexture.jpg')
const teamMiddleAlpha = loadOptimizedTexture('textures/teamworkMiddleAlpha.jpg')
const teamMiddleTexture = loadOptimizedTexture('textures/teamworkMiddleTexture.jpg')
const teamFrontAlpha = loadOptimizedTexture('textures/teamworkFrontAlpha.jpg')
const teamCircleSpinAlpha = loadOptimizedTexture('textures/teamworkCircleSpinAlpha.jpg')
const teamCircleFrameAlpha = loadOptimizedTexture('textures/teamworkCircleFrameAlpha.jpg')

//Projects
//Beat Boxer
const bBSpinAlpha = loadOptimizedTexture('textures/BBSpinAlpha.jpg')
const bBMidAlpha = loadOptimizedTexture('textures/BBMidAlpha.jpg')
const bBMidTexture = loadOptimizedTexture('textures/BBMidTexture.jpg')
const bBFrontAlpha = loadOptimizedTexture('textures/BBFrontAlpha.jpg')
//JTF
const JTFBackAlpha = loadOptimizedTexture('textures/JTFBackAlpha.jpg')
const JTFSpinAlpha = loadOptimizedTexture('textures/JTFSpinAlpha.jpg')
const JTFMidAlpha = loadOptimizedTexture('textures/JTFMidAlpha.jpg')
const JTFMidTexture = loadOptimizedTexture('textures/JTFMidTexture.jpg')
//NL
const NLFrontAlpha = loadOptimizedTexture('textures/NLFrontAlpha.jpg')
const NLSpinAlpha = loadOptimizedTexture('textures/NLSpinAlpha.jpg')
const NLMidAlpha = loadOptimizedTexture('textures/NLMidAlpha.jpg')
const NLMidTexture = loadOptimizedTexture('textures/NLMidTexture.jpg')

//section 5
//circles
const todayCircleInnerAlpha = loadOptimizedTexture('textures/todayCircleInnerAlpha.jpg')
const todayCircleMiddleAlpha = loadOptimizedTexture('textures/todayCircleMiddleAlpha.jpg')
const todayCircleOuterAlpha = loadOptimizedTexture('textures/todayCircleOuterAlpha.jpg')

//Today me and strokes
const todayMiddleAlpha = loadOptimizedTexture('textures/todayMiddleAlpha.jpg')
const todayMiddleTexture = loadOptimizedTexture('textures/todayMiddleTexture.jpg')
const todayFrontAlpha = loadOptimizedTexture('textures/todayFrontAlpha.jpg')
const todayBackAlpha = loadOptimizedTexture('textures/todayBackAlpha.jpg')

//section6
const musicCircleAlpha = loadOptimizedTexture('textures/musicCircle.jpg')
const musicCircleSpinAlpha = loadOptimizedTexture('textures/musicCircleSpin.jpg')

const gamingCircleAlpha = loadOptimizedTexture('textures/gamingCircle.jpg')
const gamingCircleSpinAlpha = loadOptimizedTexture('textures/gamingCircleSpin.jpg')

const readingCircleAlpha = loadOptimizedTexture('textures/readingCircle.jpg')
const readingCircleSpinAlpha = loadOptimizedTexture('textures/readingCircleSpin.jpg')

//section 7
const mailCircleAlpha = loadOptimizedTexture('textures/mailCircle.jpg')
const linkedinCircleAlpha = loadOptimizedTexture('textures/linkedinCircle.jpg')
const linkedinSpinAlpha = loadOptimizedTexture('textures/linkedinSpin.jpg')
const phoneCircleAlpha = loadOptimizedTexture('textures/phoneCircle.jpg')


//Section one
const outerAlpha = loadOptimizedTexture('textures/homeBackStrokeAlpha.jpg')
const middleTexture = loadOptimizedTexture('textures/meFrontCoverImage.jpg')
const middleAlpha = loadOptimizedTexture('textures/meFrontCoverImageAlpha.jpg')
const innerAlpha = loadOptimizedTexture('textures/homeFrontStrokeAlpha.jpg')

//rotating behind head
const circleAlpha4 = loadOptimizedTexture('textures/circle4.jpg')
const circleAlpha3 = loadOptimizedTexture('textures/circle3.jpg')
const circleAlpha2 = loadOptimizedTexture('textures/circle2.jpg')
const circleAlpha1 = loadOptimizedTexture('textures/circle1.jpg')

// RayCaster
const raycaster = new THREE.Raycaster()

const objectsDistance = 4

function createPlane(materialColour, xSize, ySize, xPosition, yPosition, zPosition) {
    const material = new THREE.MeshBasicMaterial({
        color: materialColour
    });

    const mesh = new THREE.Mesh(
        new THREE.PlaneGeometry(xSize, ySize),
        material
    );

    mesh.position.set(
        xPosition,
        -objectsDistance * yPosition,
        zPosition
    );

    return mesh;
}

function createImage(textureName, xSize, ySize, xPosition, yPosition, zPosition) {
    // const texture = textureLoader.load(`textures/${textureName}.jpg`)
    const material = new THREE.MeshBasicMaterial({
        map: textureName
    })
    const mesh = new THREE.Mesh(
        new THREE.PlaneGeometry(xSize, ySize),
        material
    )
    mesh.position.set(
        xPosition,
        -objectsDistance * yPosition,
        zPosition
    )

    return mesh;
}

function createAlphaImage(textureName, alphaColor, xSize, ySize, xPosition, yPosition, zPosition) {
    // const texture = textureLoader.load(`textures/${textureName}.jpg`)
    // textureName.colorSpace = THREE.SRGBColorSpace; 
    const material = new THREE.MeshBasicMaterial({
        color: alphaColor,
        transparent: true,
        alphaMap: textureName,
        depthWrite: false,
        
    })
    const mesh = new THREE.Mesh(
        new THREE.PlaneGeometry(xSize, ySize),
        material
    )
    mesh.position.set(
        xPosition,
        -objectsDistance * yPosition,
        zPosition
    )

    return mesh;
}

function createCroppedImage(textureMap, alphaMap, xSize, ySize, xPosition, yPosition, zPosition) {
    // const texture = textureLoader.load(`textures/${textureName}.jpg`)
    textureMap.colorSpace = THREE.SRGBColorSpace; 
    const material = new THREE.MeshBasicMaterial({
        map: textureMap,
        alphaMap: alphaMap,
        transparent: true,
        depthWrite: false,
        premultipliedAlpha: true
    })
    const mesh = new THREE.Mesh(
        new THREE.PlaneGeometry(xSize, ySize),
        material
    )
    mesh.position.set(
        xPosition,
        -objectsDistance * yPosition,
        zPosition
    )
    return mesh;
}

//Section 1
const circle4 = createAlphaImage(circleAlpha4, parameters.blueColor, 3, 3, 0, 0, 0)
const circle3 = createAlphaImage(circleAlpha3, parameters.blueColor, 3, 3, 0, 0, 0)
const circle2 = createAlphaImage(circleAlpha2, parameters.blueColor, 3, 3, 0, 0, 0)
const circle1 = createAlphaImage(circleAlpha1, parameters.blueColor, 3, 3, 0, 0, 0)

const alphaOuter = createAlphaImage(outerAlpha, parameters.yellowColor, 3, 3, 0, 0, 0)
const croppedMiddle = createCroppedImage(middleTexture, middleAlpha,3, 3, 0, 0, 0)
const alphaInner = createAlphaImage(innerAlpha, parameters.yellowColor, 3, 3, 0, 0, 0)

const introGraphicCircleGroup = new THREE.Group();
introGraphicCircleGroup.add(circle4, circle3, circle2, circle1)
introGraphicCircleGroup.position.set(1.2, 0, 1)

const introGraphicMeGroup = new THREE.Group();
introGraphicMeGroup.add(alphaOuter, croppedMiddle, alphaInner)
introGraphicMeGroup.position.set(1.7, 0, 1)

const section1 = new THREE.Group();
section1.add(introGraphicCircleGroup, introGraphicMeGroup)


//Section 2
const LittleMeInnerSpin = createAlphaImage(LittleMeInnerAlpha, parameters.redColor,4, 4, 0, 0, 0)
const LittleMeInner2Spin = createAlphaImage(LittleMeInner2Alpha, parameters.redColor,4, 4, 0, 0, 0)
const LittleMeMidSpin = createAlphaImage(LittleMeMidAlpha, parameters.redColor,4, 4, 0, 0, 0)
const LittleMeMiddleSpin = createAlphaImage(LittleMeMiddleAlpha, parameters.redColor,4, 4, 0, 0, 0)
const LittleMeMid2Spin = createAlphaImage(LittleMeMid2Alpha, parameters.redColor,4, 4, 0, 0, 0)
const croppedLittleMe = createCroppedImage(croppedLittleMeTexture, croppedLittleMeAlpha,4, 4, 0, 0, 0)

const littleMeGroup = new THREE.Group();

littleMeGroup.position.set(-2,0,0);

littleMeGroup.add(croppedLittleMe, LittleMeInnerSpin, LittleMeInner2Spin, LittleMeMidSpin, LittleMeMid2Spin, LittleMeMiddleSpin)

const section2 = new THREE.Group();

section2.add(littleMeGroup)

//Section 3

const teamBackAlphaShape = createAlphaImage(teamBackAlpha, parameters.blueColor, 3.5, 3.5, 0, 0, 0)
const teamHandsShape = createCroppedImage(teamHandTexture, teamHandAlpha,3.5, 3.5, 0, 0, 0)
const teamMiddleShape = createCroppedImage(teamMiddleTexture, teamMiddleAlpha,3.5, 3.5, 0, 0, 0)
const teamFrontAlphaShape = createAlphaImage(teamFrontAlpha, parameters.blueColor, 3.5, 3.5, 0, 0, 0)
const teamCircleFrameShape = createAlphaImage(teamCircleFrameAlpha, parameters.yellowColor, 3.5, 3.5, 0, 0, 0)
const teamCircleSpinShape = createAlphaImage(teamCircleSpinAlpha, parameters.yellowColor, 3.5, 3.5, 0, 0, 0)

const teamGroup = new THREE.Group();
teamGroup.position.set(2, 0, 0)
teamGroup.add(teamBackAlphaShape, teamHandsShape, teamMiddleShape, teamCircleFrameShape, teamCircleSpinShape)
const section3 = new THREE.Group();
section3.add(teamGroup)


//Section 4
// Beat Boxer
const bBSpinAlphaShape = createAlphaImage(bBSpinAlpha, parameters.blueColor, 1.25, 1.25, 0, 0, 0)
const bBMidShape = createCroppedImage(bBMidTexture, bBMidAlpha,1.25, 1.25, 0, 0, 0)
const bBFrontAlphaShape = createAlphaImage(bBFrontAlpha, parameters.blueColor, 1.25, 1.25, 0, 0, 0)

// Next spot cords
const JTFSpinAlphaShape = createAlphaImage(JTFSpinAlpha, parameters.redColor, 1.25, 1.25, 0, 0, 0)
const JTFBackAlphaShape = createAlphaImage(JTFBackAlpha, parameters.redColor, 1.25, 1.25, 0, 0, 0)
const JTFMidAlphaShape = createCroppedImage(JTFMidTexture, JTFMidAlpha, 1.25, 1.25, 0, 0, 0)

// NL Icon
const NLSpinAlphaShape = createAlphaImage(NLSpinAlpha, parameters.yellowColor, 1.25, 1.25, 0, 0, 0)
const NLFrontAlphaShape = createAlphaImage(NLFrontAlpha, parameters.yellowColor, 1.25, 1.25, 0, 0, 0)
const NLMidAlphaShape = createCroppedImage(NLMidTexture, NLMidAlpha, 1.25, 1.25, 0, 0, 0)

const beatBoxerGroup = new THREE.Group();
beatBoxerGroup.add(bBSpinAlphaShape, bBFrontAlphaShape, bBMidShape)
beatBoxerGroup.position.set(-2.5, 0.8, 0.2)

const justTheFactsGroup = new THREE.Group();
justTheFactsGroup.add(JTFBackAlphaShape, JTFMidAlphaShape, JTFSpinAlphaShape)
justTheFactsGroup.position.set(-1, 0, 0.2)

const nightLifeGroup = new THREE.Group();
nightLifeGroup.add(NLFrontAlphaShape, NLMidAlphaShape, NLSpinAlphaShape)
nightLifeGroup.position.set(-2.5, -0.8, 0.2)


const section4 = new THREE.Group();
section4.add(beatBoxerGroup, justTheFactsGroup, nightLifeGroup)

//section 5 Today

const todayBackShape = createAlphaImage(todayBackAlpha, parameters.redColor, 3, 3, 0, 0, 0)

const todayCircleInnerShape = createAlphaImage(todayCircleInnerAlpha, parameters.yellowColor, 3, 3, 0, 0, 0)
const todayCircleMiddleShape = createAlphaImage(todayCircleMiddleAlpha, parameters.yellowColor, 3, 3, 0, 0, 0)
const todayCircleOuterShape = createAlphaImage(todayCircleOuterAlpha, parameters.yellowColor, 3, 3, 0, 0, 0)

const todayMiddleShape = createCroppedImage(todayMiddleTexture, todayMiddleAlpha,3, 3, 0, 0, 0)
const todayFrontShape = createAlphaImage(todayFrontAlpha, parameters.redColor, 3, 3, 0, 0, 0)

const todayMeGroup = new THREE.Group();
todayMeGroup.add(todayCircleInnerShape, todayCircleMiddleShape, todayCircleOuterShape, todayBackShape, todayMiddleShape, todayFrontShape)
todayMeGroup.position.set(1.7, 0, 1)

const section5 = new THREE.Group();
section5.add(todayMeGroup)

//section 6 This be the hobbies

const gamingShape = createAlphaImage(gamingCircleAlpha, parameters.redColor, 1, 1, 0, 0, 0)
const gamingSpinShape = createAlphaImage(gamingCircleSpinAlpha, parameters.redColor, 1, 1, 0, 0, 0)

const musicShape = createAlphaImage(musicCircleAlpha, parameters.blueColor, 1, 1, 0, 0, 0)
const musicSpinShape = createAlphaImage(musicCircleSpinAlpha, parameters.blueColor, 1, 1, 0, 0, 0)

const readingShape = createAlphaImage(readingCircleAlpha, parameters.yellowColor, 1, 1, 0, 0, 0)
const readingSpinShape = createAlphaImage(readingCircleSpinAlpha, parameters.yellowColor, 1, 1, 0, 0, 0)

const gamingGroup = new THREE.Group();
gamingGroup.add(gamingShape, gamingSpinShape)
gamingGroup.position.set(2.75, 1.1, 0.2)

const musicGroup = new THREE.Group();
musicGroup.add(musicShape, musicSpinShape)
musicGroup.position.set(2.75, -0.1, 0.2)

const readingGroup = new THREE.Group();
readingGroup.add(readingShape, readingSpinShape)
readingGroup.position.set(2.75, -1.3, 0.2)

const section6 = new THREE.Group();
section6.add(gamingGroup, musicGroup, readingGroup)


//section 7
const linkedinShape = createAlphaImage(linkedinCircleAlpha, parameters.blueColor, 1, 1, 0, 0, 0)
const linkedinSpinShape = createAlphaImage(linkedinSpinAlpha, parameters.blueColor, 1, 1, 0, 0, 0)
const mailShape = createAlphaImage(mailCircleAlpha, parameters.redColor, 1, 1, 0, 0, 0)
const mailSpinShape = createAlphaImage(linkedinSpinAlpha, parameters.redColor, 1, 1, 0, 0, 0)
const phoneShape = createAlphaImage(phoneCircleAlpha, parameters.yellowColor, 1, 1, 0, 0, 0)
const phoneSpinShape = createAlphaImage(linkedinSpinAlpha, parameters.yellowColor, 1, 1, 0, 0, 0)

const linkedinGroup = new THREE.Group();
linkedinGroup.add(linkedinShape, linkedinSpinShape)
linkedinGroup.position.set(2.75, 1, 0.2)

const mailGroup = new THREE.Group();
mailGroup.add(mailShape, mailSpinShape)
mailGroup.position.set(1, 0, 0.2)

const phoneGroup = new THREE.Group();
phoneGroup.add(phoneShape, phoneSpinShape)
phoneGroup.position.set(2.75, -1, 0.2)

const section7 = new THREE.Group();
section7.add(linkedinGroup, mailGroup, phoneGroup)

//position

//section 3

section1.position.y = - objectsDistance * 0

section2.position.y = - objectsDistance * 1

section3.position.y = - objectsDistance * 2

section4.position.y = - objectsDistance * 3

section5.position.y = - objectsDistance * 4

section6.position.y = - objectsDistance * 5

section7.position.y = - objectsDistance * 6



scene.add(section1, section2, section3, section4, section5, section6, section7)

const sectionMeshes = [section1, section2, section3, section4, section5, section6, section7]

/**
 * Particles
 */
//Geometry
const particlesCount = 700

const positions = new Float32Array(particlesCount * 3)
const particleColors = new Float32Array(particlesCount * 3)

const colorPalette = [
    new THREE.Color(parameters.blueColor),
    new THREE.Color(parameters.yellowColor),
    new THREE.Color(parameters.redColor)
]

for (let i = 0; i < particlesCount; i++) {
    positions[i * 3 + 0] = (Math.random() - 0.5) * 10
    positions[i * 3 + 1] = objectsDistance * 0.5 - Math.random() * objectsDistance * sectionMeshes.length
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10

    const mixedColor = colorPalette[Math.floor(Math.random() * colorPalette.length)]
    particleColors[i * 3 + 0] = mixedColor.r
    particleColors[i * 3 + 1] = mixedColor.g
    particleColors[i * 3 + 2] = mixedColor.b

}
const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
particlesGeometry.setAttribute('color', new THREE.BufferAttribute(particleColors, 3))

//Material
const particlesMaterial = new THREE.PointsMaterial({
    sizeAttenuation: true,
    size: 0.03,
    vertexColors: true
})


//Particles
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)


/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.position.set(1, 1, 0)
scene.add(directionalLight)

/**
 * Sizes
 */
const sectionRuler = document.querySelector('section.doubleHSection');

const sizes = {
    width: window.innerWidth,
    height: canvas.clientHeight
}


// A dedicated function to manage responsive 3D layouts
const updatePositionsForScreenSize = () => {
    const isMobile = sizes.width < 768;

    if (isMobile) {
        // --- MOBILE LAYOUT ---
        // Scale groups down and push them in the opposite direction of their contents to center them
        section1.scale.set(0.6, 0.6);
        section1.position.set(0, (- objectsDistance * 0))
        introGraphicCircleGroup.position.set(0, 1.2, 0)
        introGraphicMeGroup.position.set(0.5, 1.4, 0)
        
        section2.scale.set(0.6, 0.6);
        section2.position.set(0, (- objectsDistance * 1))
        littleMeGroup.scale.set(0.75, 0.75)
        littleMeGroup.position.set(0, 1.25, 0)

        section3.scale.set(0.5, 0.5, 0.5);
        section3.position.set(0, (- objectsDistance * 2))
        teamGroup.position.set(0,1,0)

        section4.scale.set(0.6, 0.6, 0.6);
        section4.position.set(0, (- objectsDistance * 3))
        beatBoxerGroup.position.set(0,1.8,0)
        justTheFactsGroup.position.set(0.8,0.5,0)
        nightLifeGroup.position.set(-0.8,0.5,0)

        section5.scale.set(0.6, 0.6, 0.6);
        section5.position.set(0, (- objectsDistance * 4))
        todayMeGroup.position.set(0, 1, 0)

        section6.scale.set(0.6, 0.6, 0.6);
        section6.position.set(0, (- objectsDistance * 5))
        gamingGroup.position.set(1, -0.2, 0)
        musicGroup.position.set(1, -1.4, 0)
        readingGroup.position.set(1, -2.6, 0)

        section7.scale.set(0.6, 0.6, 0.6);
        section7.position.set(0, (- objectsDistance * 6))
        linkedinGroup.position.set(0,0,0)
        mailGroup.position.set(-0.8,-1.5,0)
        phoneGroup.position.set(0.8,-1.5,0)


    } else {
        // --- DESKTOP LAYOUT (Your original code) ---
        section1.scale.set(1, 1, 1);
        section1.position.set(0, (- objectsDistance * 0))
        introGraphicCircleGroup.position.set(1.2, 0, 1)
        introGraphicMeGroup.position.set(1.7, 0, 1)

        section2.scale.set(1, 1, 1);
        section2.position.set(0, (- objectsDistance * 1))
        littleMeGroup.scale.set(1, 1, 1)
        littleMeGroup.position.set(-2,0,0);

        section3.scale.set(1, 1, 1);
        section3.position.set(0, (- objectsDistance * 2))
        teamGroup.position.set(2, 0, 0)

        section4.scale.set(1, 1, 1);
        section4.position.set(0, (- objectsDistance * 3))
        beatBoxerGroup.position.set(-2.5, 0.8, 0.2)
        justTheFactsGroup.position.set(-1, 0, 0.2)
        nightLifeGroup.position.set(-2.5, -0.8, 0.2)


        section5.scale.set(1, 1, 1);
        section5.position.set(0, (- objectsDistance * 4))
        todayMeGroup.position.set(1.7, 0, 1)

        section6.scale.set(1, 1, 1);
        section6.position.set(0, (- objectsDistance * 5))
        gamingGroup.position.set(2.75, 1.1, 0.2)
        musicGroup.position.set(2.75, -0.1, 0.2)
        readingGroup.position.set(2.75, -1.3, 0.2)

        section7.scale.set(1, 1, 1);
        section7.position.set(0, (- objectsDistance * 6))
        linkedinGroup.position.set(2.75, 1, 0.2)
        mailGroup.position.set(1, 0, 0.2)
        phoneGroup.position.set(2.75, -1, 0.2)
        
    }
};

updatePositionsForScreenSize();


window.addEventListener('resize', () => {
    // 1. Measure the exact HTML layout
    sizes.width = window.innerWidth;
    sizes.height = canvas.clientHeight;

    // 2. Update Camera and Renderer
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // 3. Keep scroll engines synced
    if (window.lenis) {
        window.lenis.resize();
    }
    ScrollTrigger.refresh();

    // 4. THE -2 SHIFT FIX: Instantly snap the camera back into alignment with the text
    // NOTE: Make sure "objectsDistance" matches whatever variable name you used for spacing (usually 4)
    if (typeof objectsDistance !== 'undefined') {
        camera.position.y = - (window.scrollY / sizes.height) * objectsDistance;
    }
});

/**
 * Camera
 */
//Group
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
cameraGroup.add(camera)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Scroll for 3d objects
 */
let scrollY = window.scrollY
let currentScrollY = window.scrollY;

let currentSection = 0


window.addEventListener('scroll', () => {
    scrollY = window.scrollY
})

/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

//mouse
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (_event) =>
{
    mouse.x = _event.clientX / sizes.width * 2 - 1
    mouse.y = - (_event.clientY / sizes.height) * 2 + 1
})


const toastElement = document.getElementById('toast');

const showToast = (message) => {
    toastElement.innerText = message; 
    toastElement.classList.add('show'); 

    setTimeout(() => {
        toastElement.classList.remove('show');
    }, 2500);
};

window.addEventListener('click', () =>
{
    if(currentIntersect)
    {
        switch(currentIntersect.object)
        {
            case bBSpinAlphaShape:
                console.log('clicked Object 1')
                window.open('https://ixd-exhibit.uqcloud.net/archive/2021/synesthesia/', '_blank');
                break

            case JTFSpinAlphaShape:
                console.log('clicked Object 2')
                window.open('https://drive.google.com/drive/folders/11NGHADhwgXjGNLs088kX9qzrr8Nh8N3J?usp=drive_link', '_blank');
                break

            case NLSpinAlphaShape:
                console.log('clicked Object 3')
                window.open('https://docs.google.com/document/d/1OuuzwRh2SvGmtUtfjQq88MaQJwUOrkJyoNvsWLcebhs/edit?usp=drive_link', '_blank');
                break

            case linkedinSpinShape:
                console.log('clicked Object 4')
                window.open('https://www.linkedin.com/in/kurt-harron-58b9ba403/?isSelfProfile=true', '_blank');
                break

            case mailSpinShape:
                console.log('clicked Object 5')
                navigator.clipboard.writeText('kurtharron@gmail.com')
                showToast("Copied: kurtharron@gmail.com");
                break

            case phoneSpinShape:
                console.log('clicked Object 6')
                navigator.clipboard.writeText('0413902406')
                showToast("Copied: 0413902406");
                break
        }
    }
})

window.addEventListener('mousemove', (event) => {
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5

})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

let currentIntersect = null

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Particles
    const scalePulse = 1 + Math.sin(elapsedTime * 0.35) * 0.02; 
    particles.scale.set(scalePulse, scalePulse, scalePulse);

    particles.position.y = Math.sin(elapsedTime * 1.2) * 0.001;

    // Lenis scroll
    lenis.raf(performance.now());

    // Animate Camera
    camera.position.y = - (window.scrollY / sizes.height) * objectsDistance;
    // camera.position.y = - currentScrollY / sizes.height * objectsDistance

    const parallaxX = cursor.x * 0.2
    const parallaxY = - cursor.y * 0.2
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 2 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 2 * deltaTime

    //raycaster
    raycaster.setFromCamera(mouse, camera)

    const objectsToTest = [bBSpinAlphaShape, JTFSpinAlphaShape, NLSpinAlphaShape, linkedinSpinShape, mailSpinShape, phoneSpinShape]

    const intersects = raycaster.intersectObjects(objectsToTest)   

    for(const object of objectsToTest)
    {
        object.scale.set(1,1)
    }
    for (const intersect of intersects) {
        intersect.object.scale.set(1.075,1.075)
    }

    if(intersects.length)
    {
        if(currentIntersect === null)
        {
            console.log('mouse enter')
            document.body.style.cursor = 'pointer';
        }
        currentIntersect = intersects[0]
    }
    else
    {
        if(currentIntersect)
        {
            console.log('mouse leave')
            document.body.style.cursor = 'default';
        }
        currentIntersect = null
    }

    //section 1
    circle1.rotation.z = -elapsedTime * 0.02
    circle2.rotation.z = elapsedTime * 0.05
    circle3.rotation.z = -elapsedTime * 0.01
    circle4.rotation.z = elapsedTime * 0.02
    //section 2
    LittleMeInnerSpin.rotation.z = elapsedTime * 0.02
    LittleMeInner2Spin.rotation.z = elapsedTime * 0.08
    LittleMeMidSpin.rotation.z = -elapsedTime * 0.07
    LittleMeMiddleSpin.rotation.z = -elapsedTime * 0.02
    LittleMeMid2Spin.rotation.z = elapsedTime * 0.05
    //section 3
    teamHandsShape.rotation.z = elapsedTime * 0.02
    teamCircleSpinShape.rotation.z = -elapsedTime * 0.04
    //section 4
    bBSpinAlphaShape.rotation.z = elapsedTime * 0.04
    JTFSpinAlphaShape.rotation.z = -elapsedTime * 0.06
    NLSpinAlphaShape.rotation.z = elapsedTime * 0.08
    //section 5
    todayCircleInnerShape.rotation.z = elapsedTime * 0.04
    todayCircleMiddleShape.rotation.z = -elapsedTime * 0.07
    todayCircleOuterShape.rotation.z = elapsedTime * 0.06
    //section 6
    musicSpinShape.rotation.z = elapsedTime * 0.04
    gamingSpinShape.rotation.z = -elapsedTime * 0.07
    readingSpinShape.rotation.z = elapsedTime * 0.06
    //section 7
    linkedinSpinShape.rotation.z = elapsedTime * 0.04
    mailSpinShape.rotation.z = -elapsedTime * 0.07
    phoneSpinShape.rotation.z = elapsedTime * 0.06

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

showTime()
showTemp()

tick()